import { useNetworkDetails } from "@features/ax/assetRegistry/networks/hooks";
import { logEvent } from "@shared/analytics/analytics";
import { PageHeader } from "@shared/components/PageHeader";
import { TooltipProvider } from "@shared/ui/tooltip";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";
import { AlertTriangle } from "lucide-react";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { ActiveViolations } from "./activeViolationsCards";
import { AlertSummaryCards } from "./alertSummaryCards";
import { Anomalies } from "./anomaliesCards";
import { CriticalAssetsOutOfService } from "./criticalAssetCards";
import { HighMaintenanceCostAssets } from "./highMaintenanceAssetsCards";
import { OverdueInspections } from "./overdueInspectionsCards";
import { PredictiveMaintenanceAlerts } from "./predictiveMaintenanceAlertsCards";

export const AlertsLanding = () => {
  const remoteUtilityId = getRemoteUtilityId();
  const { id } = useParams();
  const { data: alertsData } = useNetworkDetails({
    networkId: id,
    tab: "alerts",
    remote_utility_id: remoteUtilityId,
  });
  useEffect(() => {
    logEvent("alerts_tab_viewed");
  }, []);

  return (
    <TooltipProvider>
      <div className="space-y-6">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-indigo-100 rounded-lg flex items-center justify-center">
            <AlertTriangle className="h-5 w-5 text-indigo-600" />
          </div>
          <div>
            <PageHeader
              title="Active Alerts"
              subtitle="Critical events, potential failures, and compliance issues requiring immediate attention"
            />
          </div>
        </div>

        {/* Summary Alert Cards */}
        <AlertSummaryCards data={alertsData} />

        {/* Critical Operational Alerts */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <CriticalAssetsOutOfService data={alertsData} />
          <Anomalies data={alertsData} />
        </div>

        {/* Performance & Predictive Alerts */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <HighMaintenanceCostAssets data={alertsData} />
          <PredictiveMaintenanceAlerts data={alertsData} />
        </div>

        {/* Compliance & Risk Alerts */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <ActiveViolations data={alertsData} />
          <OverdueInspections data={alertsData} />
        </div>
      </div>
    </TooltipProvider>
  );
};
